import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import Widget from '../../../../common/js/Widget.js';

export default class LoginWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit($widget, action => {
			Ajax.rpc('/login', {
				email: action.findField('email').val(),
				password: action.findField('password').val(),
				remember: !!action.findField('remember').is(':checked')
			}, success => {
				if (success) {
					window.location.href = '/';
				} else {
					action.error('Invalid email address or password');
				}
			}, error => {
				action.error('Login failed', error);
			});
		});
	}

}
